import consola from 'consola'
export default defineNuxtPlugin(async () => {
  const config = useRuntimeConfig();
  if (!process.client) return

  const enabled = config.public.appUpdateCheck

  consola.log(config.public.appUpdateCheck,'appUpdateCheck')

  if (!enabled) {
    consola.log('🛈 App update check disabled by env')
    return
  }

  try {
    const { useAppUpdate } = await import('@features/app-update')
    const { checkForUpdates } = useAppUpdate()

    // Первичная проверка через 3 секунды после старта
    setTimeout(() => {
      checkForUpdates()
    }, 3000)

    // Повторная проверка при возвращении в приложение
    window.addEventListener('focus', () => {
      checkForUpdates()
    })
  } catch (error) {
    consola.warn('App update check init failed', error)
  }
})